var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e4da",
    d: "M21.531 18.275h-9.843v-.487a.48.48 0 0 0-.47-.488h-.937a.48.48 0 0 0-.469.488v.487H7.47a.48.48 0 0 0-.469.488v.974c0 .269.21.488.469.488h2.343v.487a.48.48 0 0 0 .47.488h.937a.48.48 0 0 0 .469-.488v-.487h9.843a.48.48 0 0 0 .469-.488v-.974a.48.48 0 0 0-.469-.488zm0-4.5h-2.343v-.488a.48.48 0 0 0-.47-.487h-.937a.48.48 0 0 0-.468.487v.488H7.469a.48.48 0 0 0-.469.487v.976c0 .268.21.487.469.487h9.843v.487a.48.48 0 0 0 .47.488h.937a.48.48 0 0 0 .468-.488v-.487h2.344a.48.48 0 0 0 .469-.487v-.976a.48.48 0 0 0-.469-.487m0-4.8h-6.093v-.487a.48.48 0 0 0-.47-.488h-.937a.48.48 0 0 0-.469.488v.487H7.47a.48.48 0 0 0-.47.488v.975c0 .268.21.487.469.487h6.093v.487a.48.48 0 0 0 .47.488h.937a.48.48 0 0 0 .469-.488v-.487h6.093a.48.48 0 0 0 .469-.488v-.974a.48.48 0 0 0-.469-.488"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.09be06e55f7d5b2904a34d81a0d885c2.svg";
export { ForwardRef as ReactComponent };